import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { Link, useNavigate } from "react-router-dom";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "./TrendingSkills.css";

const TrendingSkills = () => {
  const navigate = useNavigate();

  // Updated to include trending skills mapped to your object fields
  const jobCategories = [
    { job: "Python", name: "python" },
    { job: "SQL", name: "sql" },
    { job: "Excel", name: "excel" },
    { job: "Java", name: "java" },
    { job: "AWS", name: "aws" },
    { job: "Sales", name: "sales" },
    { job: "Ms Office", name: "ms-office" },
    { job: "Javascript", name: "javascript" },
    { job: "Git", name: "git" },
    { job: "Docker", name: "docker" },
    { job: "Azure", name: "azure" },
    { job: "Kubernetes", name: "kubernetes" }
  ];

  return (
    <Container className="my-4">
      {/* Scope everything under the parent class wrapper */}
      <div className="trending-skills-slider">
        <Row className="align-items-center g-0">
          
          {/* Left Title - Explicit column size */}
          <Col xs={12} md={2} className="slider-header mb-2 mb-md-0">
            <h5 className="mb-0 fw-bold text-nowrap">Trending skills</h5>
          </Col>

          {/* Controls & Swiper Area */}
          <Col xs={12} md={10}>
            <Row className="align-items-center g-0 position-relative">
              
              {/* Prev Button Column */}
              <Col xs="auto" className="text-start">
                <button className="custom-nav-btn custom-prev-btn" aria-label="Previous slide">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                    />
                  </svg>
                </button>
              </Col>

              {/* Swiper Column - Takes up the remaining space dynamically */}
              <Col className="overflow-hidden px-2">
                <Swiper
                  modules={[Navigation, Autoplay]}
                  navigation={{
                    prevEl: ".trending-skills-slider .custom-prev-btn",
                    nextEl: ".trending-skills-slider .custom-next-btn",
                  }}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }}
                  slidesPerView="auto"
                  spaceBetween={10}
                  freeMode={true}
                  className="skillsSwiper"
                >
                  {jobCategories.map((items, index) => (
                    <SwiperSlide key={index} style={{ width: "auto" }}>
                      <div
                        onClick={() => navigate(`/jobexp?id=${items?.name}`)}
                        className="skill-badge-btn"
                      >
                        {items.job}
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Col>

              {/* Next Button Column */}
              <Col xs="auto" className="text-end">
                <button className="custom-nav-btn custom-next-btn" aria-label="Next slide">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </button>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default TrendingSkills;